const lockBodyScroll = (enable: boolean) => {
  if (enable) {
    document.body.style.overflowY = 'hidden';
    return;
  }
  document.body.style.overflowY = '';
};

export default lockBodyScroll;
